import {addBunchToMap} from "../overlay-utils";

export default function (mortgage, config){
    let map = {}
    let errors = []
    const digits = mortgage.activeSubmission?.mortgageAccountNo
    if (!digits) {
        errors.push('No mortgage loan account number')
    } else {
        addBunchToMap(map, 'account-', digits.toUpperCase().split(''))
    }


    return {sections:[{map,errors}]}
}